<template>
    <div class="help_center_container">
        <div class="help_center_content_wrap">
            <div class="left_cate_log_wrap" :class="{active:isExpand}">
                <div class="about_erp_title">
                    <img src="https://download.hecoos.com/enlightv/2025-12/1f027a0eda920dde526b7e91d0631261.png" alt="">
                </div>
                <el-tree :current-node-key="'1'"
                         :data="leftCateLog"
                         :expand-on-click-node="false"
                         :highlight-current="true"
                         :props="defaultProps"
                         ref="leftCateTree"
                         @node-click="handleClickLeftCateTreeNode"
                         default-expand-all
                         node-key="id">
                </el-tree>
            </div>
            <div class="expand_and_collapse_navigation" :class="{active:isExpand}">
                <span @click="handleClickExpand">
                    <i class="el-icon-arrow-left"></i>
                </span>
            </div>
            <div class="center_content_wrap" v-loading="loading">
                <div @scroll="handleContentScroll" class="content_inner_wrap" ref="content">
                    <h1 :id="centerContentData.category + '_h1'" v-text="centerContentData.name"></h1>
                    <div @click="handleClickFunctionContent"
                         class="function_content_wrap"
                         ref="function_content"
                         v-html="centerContentData.function_content">
                    </div>
                </div>
            </div>
            <div class="right_anchor_wrap" v-if="rightAnchorsList.length">
                <div class="right_anchor_title">快捷指引</div>
                <ul class="right_anchors_list">
                    <li :class="{'active':rightAnchorsActive===item.id}"
                        :key="item.id"
                        @click="handleClickRightAnchors(item)"
                        class="right_anchor_item"
                        v-for="item in rightAnchorsList"
                        v-text="item.name">
                    </li>
                </ul>
            </div>
            <el-image :preview-src-list="previewSrcList"
                      :src="imageReviewSrc"
                      class="my-img"
                      ref="imageReview"
                      style="display:none">
            </el-image>
        </div>
    </div>
</template>
<script>
export default {
    name: "HelpCenter",
    data() {
        return {
            leftCateLog: [
                {
                    id: '1',
                    name: '关于澜精灵ERP',
                    category: 'project_desc',
                    function_content: `<h2 id="project_desc_h2_1">简介</h2>
                                        <p>澜精灵ERP（以下简称澜精灵）是专为系统集成（租赁）行业打造的企业资源管理系统。
主要通过协同办公（OA）、客户管理（CRM）、库存管理、人事管理（eHR）以及财务管理五大功能板块实现销售仓储一体化、业财一体化，基于SaaS模式实现全流程业务数据无缝连接，支持PC端、移动端操作，实时高效办公。
支持个性化配置与私有化部署，实现降本增效，助力企业轻松实现数字化升级。</p>
                                        <img src="https://download.hecoos.com/enlightv/2024-33/6pXDJjMTfGiyadDHFJN4.png" alt="">
                                        <h2 id="project_desc_h2_2">开始使用</h2>
                                        <h3 id="project_desc_h3_1">管理人员</h3>
                                        <p>首先，你需要创建一个企业，搭建人事架构并邀请或添加成员加入企业。</p>


                                       <div class="systemUserImgFlex" >
                                            <div>
                                                <a href="/admin/login/registering_company" target="_blank" >
                                                    <span class="icon" style="background: url('https://download.hecoos.com/enlightv/2024-33/Cmcm7bzi6JAs3zfaQQhB.png')"></span>
                                                    <div><p>第一步：创建企业</p></div>
                                                </a>
                                            </div>
                                             <div>
                                                <a href="javascript:;" data-id="20" class="current_link" >
                                                    <span class="icon" data-id="20" class="current_link" style="background: url('https://download.hecoos.com/enlightv/2024-33/sx5c37Cpz3ai4wyhipPz.png')"></span>
                                                    <div><p data-id="20" class="current_link">第二步：搭建人事架构</p></div>
                                                </a>
                                            </div>
                                            <div>
                                                <a href="javascript:;" data-id="21" class="current_link" >
                                                    <span class="icon" data-id="21" class="current_link" style="background: url('https://download.hecoos.com/enlightv/2024-33/WZPb6BzWaFRPT5cyNmkk.png')"></span>
                                                    <div><p data-id="21" class="current_link">第三步：邀请或添加成员加入企业</p></div>
                                                </a>
                                            </div>
                                             <div>
                                                <a href="javascript:;"   >
                                                    <span class="icon" style="background: url('https://download.hecoos.com/enlightv/2024-33/k4DskmQf2XNGAPitk4A2.png')"></span>
                                                    <div><p>第四步：设置员工权限</p></div>
                                                </a>
                                            </div>

                                       </div>


                                        <h3 id="project_desc_h3_2">其他员工</h3>
                                        <p>等待管理人员邀请进入，加入企业后你可开始使用澜精灵的各项功能，与企业员工协同工作。</p>

                                        <div class="systemUserImgFlex2" >
                                            <div>
                                                <a href="javascript:;"  >
                                                    <div class="icon" style="background: url('https://download.hecoos.com/enlightv/2024-33/kxtZdYaRxmsjPAQ5WnTm.png')"></div>
                                                    <div class="text">
                                                        <span>审批</span>
                                                        <p>请假、报销等在线化审批</p>
                                                    </div>
                                                </a>
                                            </div>
                                             <div>
                                                <a href="javascript:;"  >
                                                    <div class="icon" style="background: url('https://download.hecoos.com/enlightv/2024-33/3FrbQ4WwSnrm4p4nNirm.png')"></div>
                                                    <div class="text">
                                                        <span>任务</span>
                                                        <p>简单、高效的团队协作工具</p>
                                                    </div>
                                                </a>
                                            </div>
                                             <div>
                                                <a href="javascript:;"  >
                                                    <div class="icon" style="background: url('https://download.hecoos.com/enlightv/2024-33/r6KTfZENDFX8XFs65PRB.png')"></div>
                                                    <div class="text">
                                                        <span>日志</span>
                                                        <p>记录、统计工作记录</p>
                                                    </div>
                                                </a>
                                            </div>
                                             <div>
                                                <a href="javascript:;"  >
                                                    <div class="icon" style="background: url('https://download.hecoos.com/enlightv/2024-33/dPJrEzWxH6YGi55NM3dc.png')"></div>
                                                    <div class="text">
                                                        <span>知识中心</span>
                                                        <p>一站式信息查询和解决方案</p>
                                                    </div>
                                                </a>
                                            </div>
                                       </div>

                                        <h3 id="project_desc_h3_3">登录注册</h3>
                                        <p>
                                            请根据指引登录澜精灵。<br>
                                        </p>
                                        <div class="login_box">
                                             <ul>
                                                 <li>
                                                     <a href="/Admin/login/index" target="_blank">
                                                         <div class="icon" style="background: url('https://download.hecoos.com/enlightv/2024-33/tEfb4yGYTGrW8hGWSSPb.png')"></div>
                                                         <p>PC端点击入口</p>
                                                     </a>
                                                  </li>
                                                  <li class="mobile_login">
                                                    <a href="javascript:;" class="mobile_login">
                                                         <div class="mobile_login icon" style="background: url('https://download.hecoos.com/enlightv/2024-33/WeHKryAKMdXWTwmnyjkf.png')"></div>
                                                         <p class="mobile_login">移动端点击入口</p>
                                                    </a>
                                                  </li>
                                             </ul>
                                        </div>
                                        <h3 id="project_desc_h3_4">快速上手功能</h3>
                                        <p>
                                            澜精灵可以帮助你以及企业更高效的使用系统。点击下方各个功能，快速了解如何使用。
                                        </p>
                                         <div class="systemUserImgFlex systemUserImgFlex3" >
                                            <div>
                                                <a href="javascript:;"  >
                                                    <span class="icon" style="background: url('https://download.hecoos.com/enlightv/2024-33/5SzCzsBfszRPMnrPaHHb.png')"></span>
                                                    <div><p>协同办公</p></div>
                                                </a>
                                            </div>
                                            <div>
                                                <a href="javascript:;"  >
                                                    <span class="icon" style="background: url('https://download.hecoos.com/enlightv/2024-33/ptpS6YR7Ewa8dSkxmjNN.png')"></span>
                                                    <div><p>客户管理</p></div>
                                                </a>
                                            </div>
                                              <div>
                                                <a href="javascript:;"  >
                                                    <span class="icon" style="background: url('https://download.hecoos.com/enlightv/2024-33/C85CCXnptRGXx8tdPPXE.png')"></span>
                                                    <div><p>库存管理</p></div>
                                                </a>
                                            </div>
                                              <div>
                                                <a href="javascript:;"  >
                                                    <span class="icon" style="background: url('https://download.hecoos.com/enlightv/2024-33/zxbGfPAhbPKiS3B4QXrN.png')"></span>
                                                    <div><p>财务管理</p></div>
                                                </a>
                                            </div>
                                              <div>
                                                <a href="javascript:;"  >
                                                    <span class="icon" style="background: url('https://download.hecoos.com/enlightv/2024-33/R7JcGPshBfGBMPmYG6GY.png')"></span>
                                                    <div><p>工单管理</p></div>
                                                </a>
                                            </div>
                                              <div>
                                                <a href="javascript:;"  >
                                                    <span class="icon" style="background: url('https://download.hecoos.com/enlightv/2024-33/n53dspzsRe5ZjSJt3W64.png')"></span>
                                                    <div><p>人事管理</p></div>
                                                </a>
                                            </div>


                                       </div>
                                        <h3 id="project_desc_h3_5">了解更多</h3>
                                        <div class="learn_more_wrap">
                                            <ul>
                                                <li>
                                                        更新日志
                                                </li>
                                                <li>
                                                        如何打造专属公众号
                                                </li>
                                            </ul>
                                        </div>
                                        `,
                    anchors_list: [
                        {
                            "id": "project_desc_h1",
                            "name": "关于澜精灵"
                        },
                        {
                            "id": "project_desc_h2_1",
                            "name": "欢迎大家使用澜精灵"
                        },
                        {
                            "id": "project_desc_h2_2",
                            "name": "开始使用澜精灵"
                        },
                        {
                            "id": "project_desc_h3_1",
                            "name": "管理人员"
                        },
                        {
                            "id": "project_desc_h3_2",
                            "name": "其他员工"
                        },
                        {
                            "id": "project_desc_h3_3",
                            "name": "登录注册"
                        },
                        {
                            "id": "project_desc_h3_4",
                            "name": "快速上手功能"
                        },
                        {
                            "id": "project_desc_h3_5",
                            "name": "了解更多"
                        }
                    ],
                },
                {
                    id: '2',
                    name: '人事管理',
                    category: 'hr_manage',
                    log_list: [
                        {
                            id: '20',
                            category: 'create_dep',
                            name: '管理员创建部门',
                            function_content: `<h2 id="create_dep_h2_1">一、功能简介</h2>
                                                <p>
                                                    谁能操作：仅超级管理员或拥有组织架构管理权限的管理员 <br>
                                                    为了使企业管理更有层次和秩序，管理员可在管理后台创建部门（新建企业会自动创建常见部门）。
                                                </p>
                                                <h2 id="create_dep_h2_2">二、操作流程</h2>
                                                <h3 id="create_dep_h3_1">创建部门</h3>
                                                <p>
                                                    1.点击<strong>人事管理>组织架构</strong><br>
                                                    2.点击新建部门，编辑<strong>部门名称、</strong>选择<strong>上级部门</strong> <br>
                                                    3.点击<strong>确定</strong>。完成新部门建立 <br>
                                                </p>
                                                <img src="https://download.hecoos.com/enlightv/2024-17/CTEHaA4STPK5aNK5d6eH.gif" alt="">
                                                <h3 id="create_dep_h3_2">创建子部门</h3>
                                                <p>1.点击要在部门创建子部门的右侧按钮，可以为选中部门<strong>添加子部门</strong></p>
                                                <img src="https://download.hecoos.com/enlightv/2024-17/PEWD3c2w4ixFxbbYmZRQ.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/s8wRfTpC7E8zwHGBRXWd.png" alt="">
                                                <h3 id="create_dep_h3_3">移动部门</h3>
                                                <p>
                                                    1.长按拖动部门至区域。<br>
                                                    2.点击需移动部门的右侧按钮，点击<strong>编辑</strong>，变更<strong>上级部门</strong>。<br>
                                                    注：拖动部门的子部门会随之移动<br>
                                                </p>
                                                <img src="https://download.hecoos.com/enlightv/2024-17/8dF86mXYAAz67kiYdiwz.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/dKxZn8WDiam4N5fct3F7.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/85CMhPdGCfpWBjx4aCTz.png" alt="">
                                                <h3 id="create_dep_h3_4">设置部门负责人</h3>
                                                <p>
                                                    1.点击需设置部门的右侧按钮，点击<strong>添加部门负责人</strong>，从全公司选择人员，可选多人。<br>
                                                    2.部门负责人的设置可应用于<strong>审批设置、权限设置</strong>
                                                </p>
                                                <img src="https://download.hecoos.com/enlightv/2024-17/sAhJcKcKtNB6YSTeBCpD.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/yP8MJKYffY7fm48en8FF.png" alt="">`,
                            anchors_list: [
                                {
                                    "id": "create_dep_h1",
                                    "name": "管理员创建部门"
                                },
                                {
                                    "id": "create_dep_h2_1",
                                    "name": "一、功能简介"
                                },
                                {
                                    "id": "create_dep_h2_2",
                                    "name": "二、操作流程"
                                },
                                {
                                    "id": "create_dep_h3_1",
                                    "name": "创建部门"
                                },
                                {
                                    "id": "create_dep_h3_2",
                                    "name": "创建子部门"
                                },
                                {
                                    "id": "create_dep_h3_3",
                                    "name": "移动部门"
                                },
                                {
                                    "id": "create_dep_h3_4",
                                    "name": "设置部门负责人"
                                }
                            ],
                        },
                        {
                            id: '21',
                            category: 'add_person',
                            name: '管理员添加人员',
                            function_content: `<h2 id="add_person_h2_1">一、功能简介</h2>
                                                <p>
                                                    谁能操作：仅超级管理员或拥有成员管理权限的管理员 <br>
                                                    在澜精灵上完成企业创建后，管理员可以通过 <strong>添加人员、</strong><strong>批量添加人员、</strong><strong>新员工加入、</strong><strong>添加企业人员</strong> <br>
                                                    多种方式实现员工加入企业，便于员工进行内部沟通和协作。
                                                </p>
                                                <h2 id="add_person_h2_2">二、操作流程</h2>
                                                <h3 id="add_person_h3_1">单次添加人员</h3>
                                                <p>
                                                    1.点击<strong>人事管理>人员管理or 人事管理>组织架构</strong><br>
                                                    2.点击<strong>新增员工</strong><br>
                                                    3.填写员工必填信息，<strong>点击保存。完成员工添加。</strong><br>
                                                    4.添加后需员工注册登录后激活【点击激活】<br>
                                                </p>
                                                <img src="https://download.hecoos.com/enlightv/2024-17/GbtmiMeyPaXZrMMG3tnQ.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/wcrb87jMtnj72ZGQJ3Sm.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/jnR462Nc7cM38dYeMbC3.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/sZ6tfkcE7h7pTiAc5zY6.png" alt="">
                                                <h3 id="add_person_h3_2">批量添加人员</h3>
                                                <p>1.点击人员管理<strong>导入</strong> ，下载<strong>模板</strong>，根据模板填写信息后上传</p>
                                                <img src="https://download.hecoos.com/enlightv/2024-17/287ezkzCdn8KNP63WmcY.png" alt="">
                                                <h3 id="add_person_h3_3">新员工加入</h3>
                                                <p>
                                                    1.点击右上角<strong>邀请加入</strong> <br>
                                                    2.新员工加入：复制链接or下载二维码发送给新员工。<br>
                                                    3.新员工填写信息后需管理员确认入职即可加入 <br>
                                                </p>
                                                <img src="https://download.hecoos.com/enlightv/2024-17/88YYkQihexyGHWycmHzb.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/NQ6TnpPRPmH23m8hJjiM.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/beazrpfD4Mr2AzwFQssP.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/nFTKrPefFdGcxc8NDQp8.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/AkG3nnsbR3rRtizxpwdh.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/zWep7PrJf53eYH4pFMpm.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/ytHrrZTAJFSCaJ6CG7xr.png" alt="">
                                                <h3 id="add_person_h3_4">企业链接邀请</h3>
                                                <p>
                                                    1.点击右上角<strong>邀请加入</strong> <br>
                                                    2.切换至添加企业人员。（此操作适用于企业初始化人员加入）<br>
                                                    3.复制链接or下载二维码发送给员工，员工可自行注册加入。<br>
                                                </p>
                                                <img src="https://download.hecoos.com/enlightv/2024-17/jiecSJQE48Rtywp4DJ44.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/kEikx5QrrXXbNyDj8HHF.png" alt="">
                                                <h2 id="add_person_h2_3">三、常见问题</h2>
                                                <h3 id="add_person_h3_5">问：非管理员可以邀请员工加入企业吗？</h3>
                                                <p>答：暂不可以，但通知管理员<strong>将企业邀请二维码or链接</strong>发送给非管理员，才能邀请员工加入企业。</p>
                                                <h3 id="add_person_h3_6">问：管理人员如何查看邀请的企业员工？</h3>
                                                <p>答：员工通过邀请途径自动加入企业，消息会自动通知，可在人员管理查看新加入员工。</p>
                                                <h3 id="add_person_h3_7">问：添加人员时手机号等信息编辑错误，是否可更改。</h3>
                                                <p>答：员工的个人信息可通过员工编辑（员工列表操作列）进行更改，若员工已通过手机号注册激活成功，则手机号不可变更。</p>
                                                <h3 id="add_person_h3_8">问：如果误将员工添加进企业需将其移出，该如何操作？</h3>
                                                <p>答：如未激活撤销员工添加，如已激活可参考<span class="to_document" data-id="22">发起离职</span> 。将该员工移出企业。</p>
                                                <img src="https://download.hecoos.com/enlightv/2024-17/wTrNsQBHD7imDjbFjX8e.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/b7szy8WRmp3PH5ime6YQ.png" alt="">
                                                <h3 id="add_person_h3_9">问：为什么员工显示“未注册”“未入职”？</h3>
                                                <p>答：管理人员添加员工后显示未注册，需要员工注册后才会消除未注册状态；新员工邀请会显示未入职，管理员可在入职当天确认入职。</p>
                                                <img src="https://download.hecoos.com/enlightv/2024-17/iFN2Ee72QbYG7MwTZd7t.png" alt="">`,
                            anchors_list: [
                                {
                                    "id": "add_person_h1",
                                    "name": "管理员添加人员"
                                },
                                {
                                    "id": "add_person_h2_1",
                                    "name": "一、功能简介"
                                },
                                {
                                    "id": "add_person_h2_2",
                                    "name": "二、操作流程"
                                },
                                {
                                    "id": "add_person_h3_1",
                                    "name": "单次添加人员"
                                },
                                {
                                    "id": "add_person_h3_2",
                                    "name": "批量添加人员"
                                },
                                {
                                    "id": "add_person_h3_3",
                                    "name": "新员工加入"
                                },
                                {
                                    "id": "add_person_h3_4",
                                    "name": "企业链接邀请"
                                },
                                {
                                    "id": "add_person_h2_3",
                                    "name": "三、常见问题"
                                },
                                {
                                    "id": "add_person_h3_5",
                                    "name": "问：非管理员可以邀请员工加入企业吗？"
                                },
                                {
                                    "id": "add_person_h3_6",
                                    "name": "问：管理人员如何查看邀请的企业员工？"
                                },
                                {
                                    "id": "add_person_h3_7",
                                    "name": "问：添加人员时手机号等信息编辑错误，是否可更改。"
                                },
                                {
                                    "id": "add_person_h3_8",
                                    "name": "问：如果误将员工添加进企业需将其移出，该如何操作？"
                                },
                                {
                                    "id": "add_person_h3_9",
                                    "name": "问：为什么员工显示“未注册”“未入职”？"
                                }
                            ],
                        },
                        {
                            id: '22',
                            category: 'leave_office',
                            name: '管理员操作员工离职',
                            function_content: `<h2 id="leave_office_h2_1">一、功能简介</h2>
                                                <p>
                                                    谁能操作：仅超级管理员或拥有组织架构管理权限的管理员 <br>
                                                    当管理员对指定成员操作离职时，可以将离职成员拥有的资源，转移给企业内的其他成员。操作离职后，该成员将无法访问本企业。<br>
                                                    注：已离职成员可重新入职本企业，但已转移的数据无法恢复。
                                                </p>
                                                <h2 id="leave_office_h2_2">二、操作流程</h2>
                                                <h3 id="leave_office_h3_1">操作人员离职</h3>
                                                <p>
                                                    1.点击<strong>人事管理>人员管理</strong><br>
                                                    2.选择需要离职的员工，点击“...”><strong>发起离职，进入发起离职</strong> <br>
                                                    3.填写离职时间等信息，如有交接内容，则需要交接。 <br>
                                                    4.在员工离职当日，<strong>确认离职</strong>员工即可离职，离职后将无法登录本企业。 <br>
                                                </p>
                                                <img src="https://download.hecoos.com/enlightv/2024-17/b4bYPh8wW3FKpDQw4mQb.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/nG82kEQPzPYBH8m244mb.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/ccXsPKpSHh6JS8ASAzid.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/GkW2mGzEyZmERri6rQ7F.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/dSYHaRPs4pixPaWKh6kw.png" alt="">
                                                <h3 id="leave_office_h3_2">查看离职人员</h3>
                                                <p>
                                                    1.点击人事管理>离职管理，<strong>可查看已离职的人员</strong>。<br>
                                                    2.未确认离职的员工可通过撤销离职回到未离职状态，但已交接的数据信息无法恢复。
                                                </p>
                                                <img src="https://download.hecoos.com/enlightv/2024-17/SBTfPpr53i6rcy8NdpQR.png" alt="">
                                                <img src="https://download.hecoos.com/enlightv/2024-17/nmQDwKddpFjtB7zA6472.png" alt="">
                                                <h2 id="leave_office_h2_3">三、常见问题</h2>
                                                <h3 id="leave_office_h3_3">问：操作成员离职时，如果未设置数据接收人，是否会默认将资源转交给直属上级？</h3>
                                                <p>答：是的，会默认将数据权限转移给直属上级。</p>`,
                            anchors_list: [
                                {
                                    "id": "leave_office_h1",
                                    "name": "管理员操作员工离职"
                                },
                                {
                                    "id": "leave_office_h2_1",
                                    "name": "一、功能简介"
                                },
                                {
                                    "id": "leave_office_h2_2",
                                    "name": "二、操作流程"
                                },
                                {
                                    "id": "leave_office_h3_1",
                                    "name": "操作人员离职"
                                },
                                {
                                    "id": "leave_office_h3_2",
                                    "name": "查看离职人员"
                                },
                                {
                                    "id": "leave_office_h2_3",
                                    "name": "三、常见问题"
                                },
                                {
                                    "id": "leave_office_h3_3",
                                    "name": "问：操作成员离职时，如果未设置数据接收人，是否会默认将资源转交给直属上级？"
                                }
                            ]
                        },
                    ],
                    function_content: ``,
                    anchors_list: [
                        {
                            "id": "hr_manage_h1",
                            "name": "人事管理"
                        }
                    ]
                },
            ],
            defaultProps: {
                label: 'name',
                children: 'log_list'
            },
            centerContentData: {},
            previewSrcList: [],
            imageReviewSrc: '',
            loading: false,
            rightAnchorsList: [],
            rightAnchorsActive: '',
            isScrolling: false,
            isAnchorClick: false,
            isExpand:false,
            id: '{$_REQUEST["id"]}'
        }
    },
    created() {

    },
    mounted() {
        if (this.id) {
            this.$refs.leftCateTree.setCurrentKey(this.id)
            this.handleClickLeftCateTreeNode(this.$refs.leftCateTree.getCurrentNode(), true)
        } else {
            this.handleClickLeftCateTreeNode(this.leftCateLog[0], true)
        }
    },
    methods: {
        handleClickExpand(){
            this.isExpand = !this.isExpand
        },
        handleClickReviewImage(file_path) {
            this.$refs.imageReview.showViewer = true
            this.previewSrcList = [file_path]
            this.imageReviewSrc = file_path
            Array.from(this.$refs.function_content.children).forEach(item => {
                if (item.localName === 'img') {
                    this.previewSrcList.push(item.currentSrc)
                }
            })
        },

        handleClickFunctionContent($event) {
            if (Array.from($event.target.classList).indexOf('to_document') > -1) {
                const id = $event.target.dataset.id
                window.open(`/admin/index/help_center?id=${id}`)
            }else if($event.target.className == 'current_link'){
                this.handleClickCurrentLink($event.target.dataset.id)
            }else if($event.target.className == 'mobile_login'){

                const file_path = ' https://download.hecoos.com/enlightv/2024-33/nFS47jbsFsRnzMT6nwAS.jpg'
                this.handleClickReviewImage(file_path)

            }else {
                if ($event.target.localName === 'img') {
                    const file_path = $event.target.currentSrc
                    this.handleClickReviewImage(file_path)
                }
            }
        },

        handleClickCurrentLink(id){
            this.$refs.leftCateTree.setCurrentKey(id)
            this.handleClickLeftCateTreeNode(this.$refs.leftCateTree.getCurrentNode(), true)
        },


        handleClickLeftCateTreeNode(obj, first) {
            this.loading = true
            this.centerContentData = obj
            this.rightAnchorsList = []
            this.$nextTick(() => {
                if (obj.anchors_list && obj.anchors_list.length) {
                    this.rightAnchorsList = obj.anchors_list
                    this.rightAnchorsActive = obj.anchors_list[0].id
                    this.handleClickRightAnchors(obj.anchors_list[0], first)
                }
                this.loading = false
            })
        },

        handleClickRightAnchors(item, first) {
            this.rightAnchorsActive = item.id
            this.isAnchorClick = true;
            const anchor = document.getElementById(item.id);
            if (!first) {
                anchor.classList.add('help_center_title_active')
                setTimeout(() => {
                    anchor.classList.remove('help_center_title_active');
                }, 1000);
            }
            if (anchor) {
                anchor.scrollIntoView({behavior: 'smooth'});
            }
            setTimeout(() => {
                this.isAnchorClick = false;
            }, 1000);
        },

        handleContentScroll() {
            if (!this.isAnchorClick && !this.isScrolling) {
                const scrollTop = this.$refs.content.scrollTop;
                const windowHeight = this.$refs.content.clientHeight;
                const scrollBottom = scrollTop + windowHeight;
                let activeSection = null;
                for (const section of this.rightAnchorsList) {
                    const sectionElement = document.getElementById(section.id);
                    if (sectionElement) {
                        const sectionTop = sectionElement.offsetTop;
                        const sectionBottom = sectionTop + sectionElement.offsetHeight;
                        if (scrollBottom >= sectionTop && scrollTop <= sectionBottom) {
                            activeSection = section;
                            break;
                        }
                    }
                }
                if (activeSection) {
                    this.rightAnchorsActive = activeSection.id;
                }
                this.isScrolling = false;
            }
        },
    },
    watch: {},
};
</script>


<style lang="scss" >
// 全局样式
.help_center_container {
    width: 100%;
}

// 内容区域整体样式
.help_center_content_wrap {
    width: 100%;
    height: calc(100vh - 40px);
    display: flex;

    // 左侧分类树样式
    .left_cate_log_wrap {
        width: 220px;
        height: 100%;
        padding: 8px;
        color: #333333;
        box-sizing: border-box;
        overflow-y: auto;
        transition: .5s all;
        position: relative;
        &.active{
            width: 0px;
        }
        .about_erp_title{
            height: 16px;
            position: absolute;
            left: 18px;
            top: 16px;
            z-index: 10;
            img{
                margin-right: 4px ;
            }

        }
        .el-tree-node__content {
            height: 30px;
            border-radius: 6px;
            margin-bottom: 4px;
            font-size: 14px;
            color: rgba(102, 102, 102, 1);
            &:hover{
                background: rgba(0, 0, 0, 0.04);
                color: rgba(51, 51, 51, 1);
            }
        }

        .el-tree--highlight-current {
            .el-tree-node.is-current {
                > .el-tree-node__content {
                    color: rgba(41, 144, 255, 1);
                    background: rgba(41, 144, 255, 0.16);
                    font-weight: bold;
                }
            }
        }


        .el-tree-node__content>.el-tree-node__expand-icon{
            color: rgba(102, 102, 102, 1);
            margin:0 8px 0 8px;
            padding: 2px;
            border-radius: 4px;
            &:hover{
                background: rgba(0, 0, 0, 0.04);
            }
        }

        .el-tree-node__expand-icon.is-leaf{
            color: transparent !important;
            &:hover{
                background: transparent;
            }
        }
    }

    .expand_and_collapse_navigation{
        width: 13px;
        height: 100%;
        position: relative;
        &:hover{
            background: rgba(0, 0, 0, 0.04);
            span{
                display: block;
            }
        }
        &:before{
            width: 1px;
            height: 100%;
            position: absolute;
            left: 6px;
            top: 0;
            content: ' ';
            background: rgba(232, 232, 232, 1);
        }
        span{
            width: 13px;
            height: 32px;
            opacity: 1;
            border-radius: 9px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(217, 217, 217, 1);
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -16px;
            line-height: 30px;
            text-align: center;
            box-sizing: border-box;
            cursor: pointer;
            display: none;
            i{
                font-size: 12px;
                font-weight: bold;
                color: rgba(102, 102, 102, 1);
            }
            &:hover{
                background: rgba(75, 162, 255, 1);
                border-color: rgba(75, 162, 255, 1);
                i{
                    color: #fff;
                }
            }
            &:active{
                background: rgba(34, 121, 214, 1);
                border-color: rgba(34, 121, 214, 1);
                i{
                    color: #fff;
                }
            }
        }
        &.active{

        }
    }

    // 中间内容区域样式
    .center_content_wrap {
        height: 100%;
        flex: 1;
        padding: 24px 60px;
        min-width: 300px;
        box-sizing: border-box;

        img {
            max-width: 100%;
            cursor: zoom-in;
            margin: 16px 0;
            display: block;
        }

        p {
            font-size: 16px;
            line-height: 24px;
            color: #333333;
            margin: 16px 0;
        }

        h1 {
            color: #333333;
            font-weight: 600;
            font-size: 40px;
            line-height: 50px;
            margin-bottom: 16px;
            padding: 0 4px;
            border-radius: 4px;
        }

        h2 {
            color: #333333;
            font-weight: 600;
            font-size: 30px;
            line-height: 36px;
            margin: 24px 0;
            padding: 0 4px;
            border-radius: 4px;
            box-sizing: border-box;
        }

        h3 {
            color: #333333;
            font-weight: 600;
            font-size: 22px;
            line-height: 28px;
            margin-bottom: 8px;
            padding: 0 4px;
            border-radius: 4px;
            box-sizing: border-box;
        }

        .content_inner_wrap {
            //max-width: 800px;
            height: 100%;
            margin: 0 auto;
            overflow-y: auto;
            padding: 0 24px;

            .function_content_wrap {
                padding: 0 0 50px;
            }
        }

        // 其他样式
        .help_center_title_active {
            background-color: rgba(25, 144, 255, .1);
            transition: all .3s;
        }

        .to_document {
            color: #1990ff;
            cursor: pointer;
            font-weight: 500;
        }

        .systemUserImgFlex {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            > div {
                width: calc(50% - 12px);
                margin-bottom: 24px;

                a {
                    display: flex;
                    transition: .3s all;
                    border-radius: 4px;
                    text-decoration: none;
                    height: 92px;
                    background: rgba(247, 248, 250, 1);
                    padding: 24px;
                    box-sizing: border-box;
                    align-items: center;

                    &:hover {
                        box-shadow: 0px 9px 28px 2px rgba(0, 0, 0, 0.08);
                    }

                    span {
                        display: block;
                        width: 44px;
                        height: 44px;
                        background-size: cover !important;
                        margin-right: 12px;
                    }

                    div {
                        width: calc(100% - 56px);
                        margin: 0;

                        p {
                            padding: 0;
                            margin: 0 !important;
                            color: rgba(51, 51, 51, 1);
                            font-size: 16px;
                            line-height: 24px;
                            font-weight: bold;
                        }
                    }

                    img {
                        display: block;
                        height: 68px;
                    }
                }
            }
        }

        .systemUserImgFlex2 {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            > div {
                width: calc(50% - 12px);
                margin-bottom: 24px;

                a {
                    display: flex;
                    transition: .3s all;
                    border-radius: 4px;
                    text-decoration: none;
                    height: 82px;
                    background: rgba(247, 248, 250, 1);
                    padding: 16px;
                    box-sizing: border-box;
                    justify-content: space-between;

                    &:hover {
                        box-shadow: 0px 9px 28px 2px rgba(0, 0, 0, 0.08);
                    }

                    .icon {
                        width: 22px;
                        height: 22px;
                        margin-right: 8px;
                        background-size: cover !important;
                    }

                    .text {
                        width: calc(100% - 30px);

                        span {
                            display: block;
                            line-height: 22px;
                            color: rgba(51, 51, 51, 1);
                            font-size: 14px;
                            font-weight: bold;
                        }

                        p {
                            color: rgba(102, 102, 102, 1);
                            font-size: 14px;
                            margin-top: 6px;
                        }
                    }
                }
            }
        }

        .systemUserImgFlex.systemUserImgFlex3 {
            > div {
                width: calc(33% - 12px);
                margin-bottom: 24px;
            }
        }

        .learn_more_wrap {
            width: 100%;

            ul {
                display: flex;
                justify-content: space-between;

                li {
                    width: calc(50% - 8px);
                    list-style-type: none;
                    cursor: pointer;

                    &:first-child {
                        line-height: 104px;
                        background: rgba(255, 247, 232, 1);
                        text-align: center;
                        font-size: 22px;
                        color: rgba(251, 173, 19, 1);
                        font-weight: bold;
                    }

                    &:last-child {
                        line-height: 104px;
                        background: rgba(241, 255, 235, 1);
                        text-align: center;
                        font-size: 22px;
                        color: rgba(82, 196, 27, 1);
                        font-weight: bold;
                    }

                    &:hover {
                        box-shadow: 0px 9px 28px 2px rgba(0, 0, 0, 0.08);
                    }
                }
            }
        }

        .login_box {
            width: 100%;

            ul {
                li {
                    width: 100%;
                    padding: 24px 36px;
                    box-sizing: border-box;
                    background: #fff;
                    border: 1px solid rgba(25, 144, 255, 1);
                    margin-bottom: 24px;
                    transition: .3s all;
                    border-radius: 8px;
                    cursor: pointer;

                    a {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        text-decoration: none;

                        .icon {
                            width: 58px;
                            height: 58px;
                            background-size: cover !important;
                            margin-right: 24px;
                        }

                        p {
                            width: calc(100% - 82px);
                            color: rgba(25, 144, 255, 1) !important;
                            font-size: 22px;
                            line-height: 32px;
                            font-weight: bold;
                        }
                    }

                    &:hover {
                        background: rgba(25, 144, 255, 0.16);
                    }
                }
            }
        }
    }

    // 右侧锚点区域样式
    .right_anchor_wrap {
        padding: 24px 0;
        width: 240px;
        height: 100%;
        overflow-y: auto;
        box-sizing: border-box;
        overflow-x: hidden;
        .right_anchor_title{
            line-height: 24px;
            margin-bottom: 12px;
            font-size: 16px;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
        }
        .right_anchors_list {
            width: 100%;
            padding: 0 16px;
            position: relative;
            list-style: none;
            box-sizing: border-box;

            &::before {
                border-radius: 3px;
                background-color: #dee0e3;
                content: " ";
                display: block;
                height: 100%;
                left: 0;
                position: absolute;
                width: 3px;
            }

            .right_anchor_item {
                padding: 4px 0;
                line-height: 22px;
                cursor: pointer;
                color: rgba(102, 102, 102, 1);
                position: relative;
                margin-bottom: 8px;
                font-size: 14px;
                font-weight: 500;
                transition: all .3s;
                &:hover {
                    color: rgba(75, 162, 255, 1);
                }
                &:active {
                    color: rgba(34, 121, 214, 1);
                }

                &.active {
                    color: rgba(41, 144, 255, 1);
                    font-weight: bold;
                    &::before {
                        background-color: #1990ff;
                        content: " ";
                        display: block;
                        height: 100%;
                        left: -16px;
                        position: absolute;
                        width: 3px;
                        border-radius: 3px;
                        top: 0;
                    }
                }
            }
        }
    }
}


</style>

